//Global keys
let locales = {
  ok: "Aceptar",
  close: "Cerrar",
  add: "Agregar",
  cancel: "Cancelar",
  okay: "Okay",
  print: "Imprimir",
  continue: "Continuar",
  back: "Atrás",
  save: "Guardar",
  characters: "Caracteres",
  new: "Nuevo",
  required_field: "Campo Requerido",
  clearAll: "Limpiar Todo",
  clear: "Limpiar",
  selectAnOption: "Por favor seleccione una opción",
  select: "Selecccionar",
  files: "Archivos",
  remove_all: "Remover Todo",
  choose: "Elegir",
  noAvailableTags: "No hay etiquetas disponibles",
  lan_english: "Inglés",
  lan_spanish: "Español",

  all: "Todo",
  dates: "Fechas",
  days: "Dias",
  day: "Dia",
  Days: "Dias",
  Day: "Dia",
  miles: "Millas",
  kilometers: "kilómetros",
  feet: "Pies",
  hours: "Horas",
  hour: "Hora",
  Hours: "Horas",
  Hour: "Hora",
  min: "minuto",
  mins: "Mins",
  seconds: "Segundos",
  months: "Meses",
  month: "Mes",
  Months: "Meses",
  Month: "Mes",
  engineHours: "Horas de Motor",
  odometer: "Odómetro",
  select_date: "Seleccionar fecha",
  select_time: "Seleccionar hora",
  etalink_eta: "Tiempo estimado de llegada (ETA)",
  landmarks: "Puntos de referencia",
  geofences: "Geocercas",

  Monday: "L",
  Tuesday: "M",
  Wednesday: "Mi",
  Thursday: "J",
  Friday: "V",
  Saturday: "S",
  Sunday: "D",

  dtc_codes: "Códigos DTC",
  success: "Éxito",

  min: "Min",
  max: "Max",

  pending: "Pendiente",
  due: "Vencido",
  dueSoon: "Prox a Vencer",
  dueNow: "Vencido",
  pastDue: "Atrasado",
  scheduled: "Programado",
  schedule: "Programar",
  reminder: "Recordatorio",
  next: "Siguiente",
  done: "Terminado",
  edit: "Editar",
  complete: "Completar",
  update: "Actualizar",
  delete: "Eliminar",
  DELETE: "ELIMINAR",
  ago: "hace",
  // "1010": "Ya existe un registro con el nombre introducido",
  duplicated_name: "Ya existe un registro con el nombre introducido",
  invalid_params: "Parámetros incorrectos",
  invalid_params_ftp: "Error de conexión a FTP: Parámetros incorrectos",
  exist_ftp:
    "El FTP no puede ser eliminado hasta que esos horarios sean eliminados o actualizados para usar otro Servidor FTP o modo de entrega.",
  attachmentsFilesAllowed:
    "jpg, png, gif, txt, doc, docx, pdf, csv, xls, xlsx. 4MB",

  context_menu_table: "Columnas de Tabla",
  context_menu_show_all: "Mostrar Todo",
  visibility_validation_title: "!Espera!",
  visibility_validation_message: "!Debe tener al menos una columna visible¡",

  collapse: "Collapsar",
  expand: "Expandir",

  time_today_reported: "Reportado Hoy",
  time_today_not_reported: "No reportado Hoy",
  time_not_reported_seven_days: "No reportado en 7 dias",
  time_not_reported_thirty_days: "No reportado en 30 dias",

  search: "Buscar",
  noOptions: "No hay opciones",
  prev: "Anterior",
  nextp: "Siguiente",
  perPage: "por página",
  all: "todos",
  noMoreItems: "No hay más elementos.",
  //select menu
  select_all: "Seleccionar todo",
  must_select_at_least_one_option: "Selecciona una opción",
  fetching_more_list_items: "Cargando mas items...",

  //table pagination
  pag_prev: "Anterior",
  pag_next: "Siguiente",
  pag_per_page: "Por pagina",

  //table toolbar
  table_search: "Buscar",
  table_export_csv: "Exportar CSV",
  table_export_pdf: "Exportar PDF",
  table_filter: "Filtro",
  table_add: "Adicionar",
  downloadExport: "Descargar Reporte",
  table_delete: "Borrar",
  table_refresh: "Actualizar",
  table_export: "Exportar",
  table_visibility: "Visibilidad",
  table_all: "todos",
  table_share: "Compartir",

  //input search
  Search: "Buscar",
  Cancel: "Cancelar",
  Apply: "Aplicar",

  yes: "Si",
  no: "No",

  // Dates
  date_today: "Hoy",
  days_away: "Días de distancia",
  days_ago: "Días antes",
  date_current: "Actual",
  date_yesterday: "Ayer",
  date_this_week: "Esta semana",
  date_last_week: "La semana pasada",
  date_this_quarter: "Este trimestre",
  date_last_quarter: "El trimestre pasado",
  date_custom: "Personalizado",
  date_this_month: "Este Mes",
  date_last_month: "El mes pasado",
  date_last_24hours: "Últimas 24 Horas",
  date_last_yesterday: "Ayer",
  date_last_today: "Hoy",
  date_last_7days: "Últimos 7 Dias",
  date_last_15days: "Últimos 15 Dias",
  date_last_30days: "Últimos 30 Dias",
  date_last_90days: "Últimos 90 Dias",
  date_last_3months: "Últimos 3 Meses",
  date_this_nextMonth: "Próximo Mes",
  date_next_tomorrow: "Mañana",
  date_next_7days: "Próximos 7 días",
  date_next_15days: "Próximos 15 días",
  date_next_30days: "Próximos 30 días",
  date_next_90days: "Próximos 90 días",
  //for interval pill
  due_every: "Vencimiento a",
  reminder_at: "Recordatorio a",
  pastDue_at: "Atrasado en",
  next_in: "Próximo en",

  //for dates
  at_time: "a las",
  dateAndTime: "Hora y Fecha",
  start: "Inicio",
  end: "Fin",
  set: "Aplicar",

  //collapse button select menu
  show_all: "Mostrar todo",
  show_less: "Mostrar menos",
  collapse_to_ten: "Mostrar solo diez",

  menu_dashboard: "Consola",
  menu_fleet: "Estado", // Renamed from "Vehículos" temporary
  menu_vehicleStatus: "Estado de Vehiculos",
  menu_map: "Mapas",
  menu_realtimeMaps: "Mapas",
  menu_reports: "Reportes",
  menu_video: "Video",
  menu_delete: "Borrar",
  menu_add: "Agregar",
  menu_manage: "Administración",
  menu_behavior: "Comportamiento",
  menu_routes: "Rutas",
  menu_maintenance: "Mantenimiento",
  menu_fieldSync: "FieldSync",
  menu_MDT: "MDT",
  menu_FSM: "FSM",
  menu_media: "Media",
  menu_account: "Mi Cuenta",
  menu_preferences: "Preferencias",
  menu_contacts: "Contactos",
  menu_help: "Centro de ayuda",
  menu_marketplace: "Tienda",
  menu_driverStatus: "Estado de conductor",
  menu_advaceRouting: "Rutas Avanzadas",
  menu_customers: "Clientes",
  menu_rfid: "RFID",
  menu_promiles: "Promiles",
  menu_zonar_eld: "Zonar Logs",
  menu_zonar_zpass: "Z Pass",
  menu_apollo_eld: "Apollo ELD",
  menu_fleet_io: "Fleetio",
  menu_car_iq: "Car IQ Pay",
  menu_eldfleet_eld: "ELDFleet (heredado)",
  menu_evir: "EVIR",
  menu_evir_px: "EVIR",
  menu_evir_ib: "Generador de inspecciones",
  menu_inspection_builder: "Generador de inspecciones",
  menu_defect_list: "Lista de Defectos",
  menu_elogs: "Elogs",
  menu_loginHistory: "Historial Inicios de sesión",
  menu_accountInformation: "Información de la cuenta",
  menu_users: "Usuarios",
  menu_feedback: "Retroalimentación",
  menu_settings: "Opciones",
  menu_apiKeys: "API",
  menu_tags: "Etiquetas",
  menu_role: "Roles",
  menu_apps: "Aplicaciones",
  menu_dataExport: "Exportar Datos",
  menu_evirSettings: "Configuración EVIR",
  settings_title: "Configuración EVIR",
  menu_dynamic_forms: "Formularios",
  menu_billingPortal: "Portal de Facturación",
  menu_workOrders: "Órdenes de Trabajo",
  menu_driverPerformance: "Rendimiento del Conductor",

  // Iframes Monarch
  menu_netradyne_cams: "Netradyne Cams",
  menu_coach_sso: "Coaching",
  menu_monarch_driveri: "Driver I Cameras",
  menu_monarch_eld: "ELD Premium",
  menu_monarch_classic: "Classic Platform",
  menu_monarch_ditat: "DITAT TMS",
  menu_monarch_intangles: "Intangles",
  menu_xbiplus: "Inteligencia de Negocios",

  from: "from",
  to: "para",

  FROM: "recibido",
  TO: "enviado",

  error: "Error",
  information: "Información",

  errorMessage: "Ha ocurrido un error. Por favor intente de nuevo.",
  notAvailable: "N/D",
  noItemsFound: "No se encontraron coincidencias",

  download: "Descargar",
  addFavorites: "Agregar a favoritos",
  removeFavorites: "Quitar de favoritos",
  favorites: "Favoritos",
  noItemsFound: "No se encontraron coincidencias.",

  unassigned: "Sin asignar",

  excellent: "Excelente",
  fair: "Regular",
  good: "Bueno",
  poor: "Débil",
  unknown: "Desconocida",
  offline: "Fuera de Línea",
  parking: "Parqueado",
  driving: "En movimiento",
  idling: "de marcha en vacío",
  av_clips: "Clips dis",
  stopped: "Detenido",
  no_video_av: "Video No Disponible",
  others: "Otro",
  no_data: "Sin información",
  second_clip: "Rango de clips",

  low: "Bajo",
  medium: "Medio",
  high: "Alto",

  at: "a las",

  show: "Ver",
  expandAll: "Expandir",
  hide: "Ocultar",
  documentation: "Documentación",
  draw: "Dibujar control",
  zoomOut: "Alejar",
  zoomIn: "Acercar",
  layerControl: "control de capa",

  exportCSV: "Exportar CSV",
  exportPDF: "Exportar PDF",
  export: "Exportar",
  downloadExport: "Descargar Reporte",
  changeColumnOrder: "Cambiar orden de columnas",
  typeToSearch: "Escriba para buscar",
  address: "Dirección",
  unit: "Unidad",
  landmark: "Landmark",
  geofence: "Geocerca",
  unit_value: "Unidad",
  single_unit: "Unidades",
  single_driver: "Conductores",
  all_units: "Todas las unidades",
  all_drivers: "Todos los conductores",
  tags: "Etiquetas",
  all: "Todos",
  custom: "Personalizado",

  create: "Crear",
  daily: "Diario",
  weekly: "Semanal",
  monthly: "Mensual",
  assign: "Asignar",

  merge: "Combinar",
  map_legend: "Leyenda",

  //modules
  units: "Unidades",
  Unit_Groups: "Grupos de unidades",
  drivers: "Conductores",
  driver_groups: "Grupos de conductores",

  filters: "Filtros",
  apply: "Aplicar",
  //map layers
  Hybrid_layer: "Híbrido",
  Map_layer: "mapa",
  Satellite_layer: "satélite",
  Terrain_layer: "terreno",
  Camera: "Cámara",
  allow: "Permitir",

  //map fullscreen
  map_fullscreen: "Pantalla completa",

  //map traffic
  map_traffic: "Tráfico",
  map_weather: "Clima",
  map_radar: "Radar",
  map_satellite: "Satélite",
  map_heat_index: "Índice de Calor",
  map_forecasted_heat_index: "Índice de Calor Pronosticado",
  map_humidity: "Humedad",
  map_surface_analysis: "Análisis de Superficie",
  map_drought_monitor: "Monitor de Sequía",
  map_forecasted_feels_like_temperature:
    "Temperatura de Sensación Pronosticada",
  map_forecasted_jet_stream: "Corriente en Chorro Pronosticada (250mb)",
  map_forecasted_precipitation: "Precipitación Pronosticada (1 Hora)",
  map_forecasted_precipitation_6: "Precipitación Pronosticada (6 Horas)",
  map_view_detail: "Ver Detalle...",
  map_live: "EN VIVO",
  map_animation_zone: "ZONA DE ANIMACIÓN",
  map_stop_following: "Dejar de seguir",
  map_following: "SIGUIENDO",

  remove: "Remover",
  untagged: "Sin etiquetar",

  on: "Encendido",
  off: "Apagado",
  email: "Correo Electrónico",
  none: "Ninguno",
  selectAll: "Seleccionar Todo",

  exportInProcessTitle: "Exportando...",
  exportInProcessBody:
    "Esto podría llevar algún tiempo, el archivo se descargará automáticamente cuando esté listo",
  exportSuccess: "El archivo se ha descargado correctamente",

  loading: "Cargando...",
  phone: "Teléfono",
  contacts: "Contactos",
  emailAddress: "Dirección Email:",
  phoneNumber: "Número de Teléfono:",
  selectContact: "Seleccionar Contacto:",
  add_recipient: "Agregar Destinatario",
  required_email: "Por favor inserte un email válido",
  required_phone: "Por favor inserte un teléfono válido",
  select_country_code: "Seleccionar País:",
  enterEmailAddress: "Ingrese dirección de correo electrónico",
  enterPhoneNumber: "Ingrese Número de Teléfono",
  OF: "DE",
  chat: "Chat",
  troubleshooting: "Solución de problemas",
  supportAgent: "agente de soporte",
  unitOverViewPanel: "Descripción general del vehículo",
  system: "Sistema",
  driverID: "Identificación del conductor",
  vehicle: "Vehículo",
  eventID: "ID del evento",
  date: "Fecha",
  time: "Hora",
  notes: "Notas",
  errorCompanyReadOnly:
    "No es posible realizar cambios en esta entidad porque la aplicación está en modo de prueba. Comuníquese con el soporte si tiene alguna pregunta.",

  // Events
  event_all: "Todos",
  event_drive: "Conduciendo",
  event_ping: "Señal",
  event_travelstartstop: "Inicio/Fin de viaje",
  event_travelstop: "Fin de viaje",
  event_travelstart: "Inicio de viaje",
  event_ignitiononoff: "Encendido/Apagado",
  event_ignitionoff: "Apagado",
  event_ignitionon: "Encendido",
  event_driveevent: "Conduciendo",
  event_motionevent: "En movimiento",
  event_totaltime: "Tiempo Total",
  event_overspeed: "Sobre la velocidad permitida",
  event_maxspeed: "Máxima Velocidad Registrada",
  event_travelstart: "Inicio del viaje",
  event_motionstart: "Inicio del movimiento",
  event_asleep: "Dormido",
  event_auto_snapshot: "Captura automática",
  event_autosnapshot: "Captura automática",
  event_position_update: "Actualización de posición",
  event_camera_obstructed: "Cámara obstruida",
  event_close_following: "Conducción muy cercana",
  event_collision_warning: "Alerta de colisión",
  event_comm_acquired: "Comunicación adquirida",
  event_comm_lost: "Comunicación perdida",
  event_cyclist_warning: "Alerta de ciclista",
  event_data_usage: "Uso de datos",
  event_distracted: "Distraído",
  event_drive: "Conduciendo",
  event_drowsiness: "Somnolencia",
  event_face_recognition: "Reconocimiento facial",
  event_hard_brake: "Frenado brusco",
  event_hard_turn: "Giro brusco",
  event_heart_beat: "Latido",
  event_idle: "Inactivo",
  event_idle_no_driver: "En ralentí sin conductor",
  event_ignition_off_on: "Ignición Encendida/Ignición Apagada",
  event_ignition_off: "Ignición apagada",
  event_ignition_on: "Ignición encendida",
  event_lane_departure: "Salida de carril",
  event_main_power_connect: "Conexión de energía principal",
  event_main_power_disconnect: "Desconexión de energía principal",
  event_maintenancewarning: "Alerta de mantenimiento",
  event_manual: "Manual",
  event_new: "Nuevo",
  event_no_seatbelt: "Sin cinturón de seguridad",
  event_off: "Apagado",
  event_parked: "Estacionado",
  event_parking_hit: "Golpe en estacionamiento",
  event_passenger_inside: "Pasajero a bordo",
  event_passenger_seatbelt: "Pasajero sin cinturón",
  event_pedestrian_detection: "Detección de peatón",
  event_periodic_boot: "Reinicio periódico",
  event_posted_speed: "Velocidad permitida",
  event_potential_incident: "Incidente potencial",
  event_potential_incident_high: "Incidente potencial alto",
  event_potential_incident_low: "Incidente potencial bajo",
  event_potential_incident_medium: "Incidente potencial medio",
  event_power_lost: "Energía perdida",
  event_rapid_acceleration: "Aceleración brusca",
  event_sdcarderror: "Error de tarjeta SD",
  event_sdcardstatus: "Estado de tarjeta SD",
  event_smoking: "Fumando",
  event_speed_threshold: "Límite de velocidad",
  event_stop_sign_violation: "Infracción de señal de alto",
  event_tailgating: "Emergencia de Proximidad",
  event_test_ng: "Prueba NG",
  event_travel_start: "Inicio de viaje",
  event_travel_stop: "Fin de viaje",
  event_unassigned_driver: "Conductor no asignado",
  event_using_phone: "Usando teléfono",
  event_yawn: "Bostezo",
  event_checking: "Comprobando",
  event_diagnostic: "Diagnóstico",
  event_geofence_in: "Entrada a geocerca",
  event_geofence_out: "Salida de geocerca",
  event_geofence_set: "Geocerca creada",
  event_geofence_update: "Geocerca actualizada",
  event_heartbeat_checkin: "Registro de latido",
  event_input_toggle: "Cambio de entrada",
  event_internal_battery_connect: "Conexión de batería interna",
  event_low_battery: "Batería baja",
  event_output_1_disabled: "Salida 1 deshabilitada",
  event_output_1_enabled: "Salida 1 habilitada",
  event_power_off: "Apagado",
  event_power_up: "Encendido",
  event_script_update: "Actualización de script",
  event_starter_disable: "Arranque deshabilitado",
  event_starter_enable: "Arranque habilitado",
  event_tow: "Remolque",
  event_user_update: "Actualización de usuario",
  event_vehicle_movement: "Movimiento del vehículo",
  event_idling_end: "Fin de Ralenti",
  event_speeding_end: "Fin de exceso de velocidad",
  event_2_minutes_after_power_on: "2 minutos después de encender",
  event_absolute_g_wake: "Despertar G absoluto",
  event_acceleration: "Aceleración",
  event_agps_start: "Inicio de AGPS",
  event_alarm_armed: "Alarma activada",
  event_alarm_disarmed: "Alarma desactivada",
  event_alarm_off: "Alarma apagada",
  event_alarm_on: "Alarma encendida",
  event_battery_connect: "Batería conectada",
  event_battery_threshold: "Umbral de batería",
  event_battery_update: "Actualización de batería",
  event_boot_checkin: "Registro de arranque",
  event_cell_antenna_connect: "Antena celular conectada",
  event_cell_jamming_start: "Inicio de interferencia celular",
  event_cell_jamming_stop: "Fin de interferencia celular",
  event_change_of_location_area_alert: "Alerta de cambio de área de ubicación",
  event_check_engine_off: "Motor apagado (Check Engine)",
  event_check_engine_on: "Motor encendido (Check Engine)",
  event_cluster: "Clúster",
  event_cold_boot: "Arranque en frío",
  event_comm_reset: "Reinicio de comunicación",
  event_comm_reset_by_command: "Reinicio de comunicación por comando",
  event_comm_reset_no_ack: "Reinicio de comunicación sin ACK",
  event_comm_reset_no_at: "Reinicio de comunicación sin AT",
  event_consistent_speed: "Velocidad constante",
  event_crash: "Accidente",
  event_deceleration: "Desaceleración",
  event_device_info: "Información del dispositivo",
  event_device_turned_on: "Dispositivo encendido",
  event_disabled: "Deshabilitado",
  event_door_ajar: "Puerta entreabierta",
  event_door_lock: "Puerta bloqueada",
  event_door_unlock: "Puerta desbloqueada",
  event_driver_login: "Inicio de sesión del conductor",
  event_driver_logout: "Cierre de sesión del conductor",
  event_dtc_event: "Evento DTC",
  event_emergency: "Emergencia",
  event_emergency_end: "Fin de emergencia",
  event_engine_code: "Código del motor",
  event_engine_off: "Motor apagado",
  event_engine_on: "Motor encendido",
  event_engine_on_minutes_report: "Reporte de minutos encendido",
  event_engineering_message: "Mensaje de ingeniería",
  event_firmware_update: "Actualización de firmware",
  event_fuel_loss_detected: "Pérdida de combustible detectada",
  event_fuel_refill_detected: "Recarga de combustible detectada",
  event_gps_acquired: "GPS adquirido",
  event_gps_antenna_connect: "Antena GPS conectada",
  event_gps_antenna_disconnect: "Antena GPS desconectada",
  event_gps_jamming_start: "Inicio de interferencia GPS",
  event_gps_jamming_stop: "Fin de interferencia GPS",
  event_gps_not_available: "GPS no disponible",
  event_gps_position: "Posición GPS",
  event_gps_reset: "Reinicio de GPS",
  event_hard_stop: "Parada brusca",
  event_heading_change: "Cambio de rumbo",
  event_idling: "Ralentí",
  event_input_1_off: "Entrada 1 apagada",
  event_input_1_on: "Entrada 1 encendida",
  event_input_2_off: "Entrada 2 apagada",
  event_input_2_on: "Entrada 2 encendida",
  event_input_3_off: "Entrada 3 apagada",
  event_input_3_on: "Entrada 3 encendida",
  event_input_4_off: "Entrada 4 apagada",
  event_input_4_on: "Entrada 4 encendida",
  event_input_5_off: "Entrada 5 apagada",
  event_input_5_on: "Entrada 5 encendida",
  event_input_6_off: "Entrada 6 apagada",
  event_input_6_on: "Entrada 6 encendida",
  event_input_7_off: "Entrada 7 apagada",
  event_input_7_on: "Entrada 7 encendida",
  event_input_status_changed: "Estado de entrada cambiado",
  event_install_sensor: "Sensor instalado",
  event_internal_battery_disconnect: "Batería interna desconectada",
  event_internal_battery_recovered: "Batería interna recuperada",
  event_live: "En vivo",
  event_locate: "Localizar",
  event_location: "Ubicación",
  event_location_report: "Reporte de ubicación",
  event_long_engine_idle: "Motor en ralentí prolongado",
  event_loss_of_gps_fix: "Pérdida de señal GPS",
  event_low_internal_battery: "Batería interna baja",
  event_main_power_on: "Energía principal encendida",
  event_maintenance_limit_exceeded: "Límite de mantenimiento excedido",
  event_message: "Mensaje",
  event_minor: "Menor",
  event_motion: "Movimiento",
  event_motion_stop: "Fin de movimiento",
  event_no_gps: "Sin GPS",
  event_normal: "Normal",
  event_obdii_message: "Mensaje OBDII",
  event_oem_speeding: "Exceso de velocidad OEM",
  event_operator_alarm: "Alarma del operador",
  event_output_2_disabled: "Salida 2 deshabilitada",
  event_output_2_enabled: "Salida 2 habilitada",
  event_paged: "Paginado",
  event_power_down: "Apagado",
  event_power_down_stop: "Apagado detenido",
  event_power_on: "Encendido",
  event_power_protect: "Protección de energía",
  event_recentering: "Recentrado",
  event_restart: "Reinicio",
  event_rfid: "RFID",
  event_rollover: "Volcamiento",
  event_rpm_threshold: "Umbral de RPM",
  event_satellite_off: "Satélite apagado",
  event_satellite_on: "Satélite encendido",
  event_satellite_update: "Actualización de satélite",
  event_sleep: "Dormir",
  event_sms: "SMS",
  event_stand_by: "En espera",
  event_status_update: "Actualización de estado",
  event_stop: "Detener",
  event_tamper_alarm: "Alarma de manipulación",
  event_temp_trip: "Viaje de temperatura",
  event_temp_1_over_high: "Temp-1 sobre alto",
  event_temp_1_under_low: "Temp-1 bajo",
  event_temp_2_over_high: "Temp-2 sobre alto",
  event_temp_2_under_low: "Temp-2 bajo",
  event_temp_3_over_high: "Temp-3 sobre alto",
  event_temp_3_under_low: "Temp-3 bajo",
  event_temperature: "Temperatura",
  event_time: "Tiempo",
  event_tow_end: "Fin de remolque",
  event_turn: "Giro",
  event_undesired_input: "Entrada no deseada",
  event_unknown: "Desconocido",
  event_update: "Actualización",
  event_update_boot: "Actualización de arranque",
  event_vehicle_detect: "Vehículo detectado",
  event_vibration_wake: "Despertar por vibración",
  event_vin: "VIN",
  event_virtual_ignition_off: "Ignición virtual apagado",
  event_virtual_ignition_on: "Ignición virtual encendido",
  event_voltage_wake: "Despertar por voltaje",
  event_wakeup: "Despertar",
  event_wakeup_periodic: "Despertar periódico",
  event_warm_boot: "Arranque en caliente",
  event_watchdog: "Watchdog",
  event_light_sensor_alarm: "Alarma de sensor de luz",
  event_sudden_stop: "Parada repentina",
  event_trip_ongoing: "Viaje en curso",
  event_overfill: "Sobrellenado",
  event_clock_in: "Registro de entrada",
  event_clock_out: "Registro de salida",
  event_meal_break_begin: "Inicio de descanso para comida",
  event_meal_break_end: "Fin de descanso para comida",
  // Assets tab

  asset_tab_label: "Etiqueta",
  asset_tab_assetType: "Tipo de activo",
  asset_tab_assetSubtype: "Subtipo de activo",
  asset_tab_licensePlate: "Matrícula",
  asset_tab_registrationCountry: "País del Registro",
  asset_tab_registrationState: "Estado del Registro",
  asset_tab_registrationExpiration: "Fecha de expiración del Registro",
  asset_tab_vin: "VIN",
  asset_tab_make: "Marca",
  asset_tab_model: "Modelo",
  asset_tab_year: "Año",
  asset_tab_engineLiters: "Cilindraje del Motor",
  asset_tab_highway: "Autopista",
  asset_tab_city: "Ciudad",
  asset_tab_inspectionTagId: "ID de Etiqueta de Inspección",
  asset_tab_asset: "Activo",
  asset_tab_tag: "Etiqueta",
  asset_tab_tags: "Etiquetas",
  asset_tab_powerUnitNumber: "Número de unidad de potencia",
  asset_tab_decodeVIN: "Decodificar VIN",
  asset_tab_inspectionDeviceType: "Tipo de Dispositivo de Inspección",
  asset_tab_noInformationFoundVIN:
    "No se ha encontrado información para este VIN",
  asset_tab_maxValue: "Valor máx",
  asset_tab_minValue: "Valor mín",
  asset_tab_externalId: "ID Externo",
  asset_tab_createAsset: "Crear Nuevo Activo",
  asset_tab_assetSaved: "Activo Guardado",
  asset_tab_maintenance: "Mantenimiento",
  asset_tab_maintenanceCompany: "Compañía de Mantenimiento",
  asset_tab_inServiceDate: "Fecha de Entrada en Servicio",
  asset_tab_registration: "Registro",
  asset_tab_chassisSerialNumber: "Número de Serie del Chasis",
  asset_tab_engineSerialNumber: "Número de Serie del Motor",
  asset_tab_vehicleId: "ID del Vehículo",
  asset_tab_mpg: "MPG",
  asset_tab_evir: "EVIR",
  asset_tab_zonarEld: "Zonar ELD",

  driver_performance_driver_timeInfo_message: "Las agrupaciones del conductor se generan diariamente en formato UTC (Hora Servidor), por lo tanto se podran ver registros del día anterior o del día siguiente dependiendo de su zona horaria.",
  filterEventsMap_buttonLabel: "Filtros",
};

let videoEvents = {
  Asleep: "Dormido",
  "Camera Obstructed": "Cámara obstruida",
  "Close Following": "Aviso de proximidad",
  "Collision Warning": "Aviso de colisión",
  "Cyclist Warning": "Alerta de Ciclista",
  'AutoSnapshot': "Captura automática",
  'Travel Start': "Inicio de viaje",
  Distracted: "Distraído",
  Drowsiness: "Somnoliento",
  "Hard Brake": "Frenado brusco",
  "Hard Turn": "Giro fuerte",
  "Drive": "Conduciendo",
  "Idle No Driver": "Inactiva sin conductor",
  "Lane Departure": "Salida de carril",
  "Main Power Disconnect": "Desconectado principal",
  Manual: "Manual",
  "No Seatbelt": "Sin cinturón de seguridad",
  "Rolling Stop Sign": "Violación de señal de alto rodante",
  "Distracted / Using Phone": "Distraído / Usando teléfono",
  "Passenger Inside": "Detección de Pasajero",
  "Passenger Seatbelt": "Pasajero sin cinturón",
  "Pedestrian Detection": "Detección de peatones",
  "Posted Speed": "Limite de velocidad",
  "Potential Incident": "Incidente potencial",
  "Rapid Acceleration": "Aceleración Rápida",
  Smoking: "Fumando",
  "Speed Threshold": "Exceso de Velocidad",
  "Stop Sign Violation": "Violación de la señal de alto",
  Tailgating: "Emergencia de Proximidad",
  "Using Phone": "Usando el teléfono",
  Yawn: "Bostezo",
  "Day Dreaming": "Sueño diurno",
  "Parking Hit": "Impactado en estacionamiento",
  Drowsy: "Somnoliento",
  "Sudden Stop": "Parada repentina",
  Parking: "Parqueado",
  AutoSnapshot: "AutoSnapshot",
  "Potential Incident Low": "Incidente Potencial Bajo",
  "Potential Incident Medium": "Incidente Potencial Medio",
  "Potential Incident High": "Incidente Potencial Alto",
  allUnitSelected: "Todas las unidades seleccionadas",
  allDriverSelected: "Todos los conductores seleccionados",
  selectUnitsOrSearchByName: "Seleccionar unidades o buscar por nombre",
  selectDriversOrSearchByName: "Seleccionar conductores o buscar por nombre",
  selectTags: "Seleccionar etiquetas",
  selectAllTags: "Seleccionar todas las etiquetas",
  inactive: "Inactivo",
  active: "Activo",
  allForm: "Todas los Formularios",
  searchTags: "Buscar Etiquetas",
  includeInactiveDrivers: "Incluir conductores inactivos",
  includeUnassignedDrivers: "Incluir conductores no asignados",
};

//Merge Modules
import alerts from "Modules/alerts/.globals/lan/es";
import behavior from "Modules/behavior/.globals/lan/es";
import fleet from "Modules/fleet/.globals/lan/es";
import maintenance from "Modules/maintenance/.globals/lan/es";
import reports from "Modules/reports/.globals/lan/es";
import security from "Core/.globals/lan/es";
import realtimeMaps from "Modules/realtimeMaps/.globals/lan/es";
import common from "Modules/.common/.globals/lan/es";
import video from "Modules/video/.globals/lan/es";
import account from "Modules/account/.globals/lan/es";
import settings from "Modules/settings/.globals/lan/es"; //! Remove old settings module progressively
import manage from "Modules/manage/.globals/lan/es";
import dashboard from "Modules/dashboard/.globals/lan/es";
import fsm from "Modules/fsm/.globals/lan/es";
import { gtc_locales_es } from "@gpstrackit/gtc-react-controls";
import dynamicForms from "Modules/dynamicForms/.globals/lan/es";
import chat from "../../../modules/chat/.globals/lan/es";
import routes from "../../../modules/routes/.globals/lan/es";
import incidents from "Modules/incidents/.globals/lan/es";
import workOrders from "Modules/workOrders/.globals/lan/es";
import integrations from "Modules/integrations/.globals/lan/es";
import template from "Modules/.template/.globals/lan/en";
import driver from "Modules/driver/views/driverTable/lan/es";

locales = {
  ...alerts,
  ...behavior,
  ...fleet,
  ...locales,
  ...maintenance,
  ...reports,
  ...security,
  ...realtimeMaps,
  ...common,
  ...video,
  ...account,
  ...fsm,
  ...settings,
  ...manage,
  ...dashboard,
  ...gtc_locales_es,
  ...dynamicForms,
  ...chat,
  ...routes,
  ...incidents,
  ...videoEvents,
  ...workOrders,
  ...integrations,
  ...template,
  ...driver,
};

export default locales;
